import styled from "styled-components";
import { ViewAllBtn } from "../LatestBlogs/styles";

export const StyledSection = styled.section`
  background-color: #ffffff;
  width: 100%;
  padding: 20px 48px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: space-between;
  gap: 16px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding: 60px 0.8rem 20px;
    flex-direction: column;
  }
`;

export const ResourceContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 32px;
  gap: 32px;
  isolation: isolate;
  position: relative;
  overflow: hidden;

  flex-grow: 1;
  min-height: 480px;

  background: rgba(29, 29, 29, 0.04);
  border-radius: 24px;

  + .guide-card {
    width: 437px;
    flex: 0 0 437px;

    .guide-card-info {
      flex-grow: 1;
    }

    .view-guide-btn {
      margin-top: auto;
    }

    @media ${({ theme }) => theme.media.mobile} {
      flex: unset;
      width: 100%;
      // min-height: 466px;

      .view-guide-btn {
        margin-top: 32px;
      }

      .guide-card-title {
        font-size: 22px;
      }
    }
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    min-height: 466px;
  }
`;

export const BackgroundBlur = styled.div`
  position: absolute;
  width: 808px;
  height: 165px;
  left: calc(50% - 808px / 2 + 0.5px);
  bottom: -140px;

  background: ${({ theme }) => theme.colors.blurBg.trim()};
  opacity: 0.4;
  filter: blur(130px);
  border-radius: 59.0555px;

  z-index: 0;
`;

export const ResourceContentFrame = styled.div`
  margin: 0 auto;
  padding: 0px;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  flex-grow: 0;
  z-index: 1;
`;

export const ResourceContentFrameHeader = styled.div`
  width: 100%;
  height: fit-content;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;

  color: rgba(29, 29, 29, 0.5);
`;

export const ResourceContentFrameText = styled.div`
  max-width: 595px;
  width: 100%;
  height: fit-content;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 44px;
  line-height: 130%;
  letter-spacing: -0.02em;

  color: rgba(29, 29, 29, 0.85);

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    font-size: 28px;
    line-height: 1.3;
    letter-spacing: unset;
  }
`;

export const HeadingHighlight = styled.span`
  color: rgba(29, 29, 29, 0.5);
  font-family: inherit;
`;

export const ReadAllBtn = styled(ViewAllBtn)`
  margin: 0;
`;
